import { useMemo, useState, useCallback, useRef } from 'react';
import 
{ 
  Box, 
  CircularProgress, 
  IconButton, 
  Typography, 
  Button, 
  TextField, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle 
} from '@material-ui/core';
import { DeleteForever, Edit } from '@material-ui/icons';
import AdminMenu from '../../../components/Admin/MenuDetalhes/AdminMenu';
import DataTable from '../../../components/DataTable';
import useResumosDeAula from './useResumosDeAula';
import { formatDate } from '../../../utils/Utils';
import { RESUMOS_FILTERS } from './useResumosDeAula';
import cleanTitle from '../../../utils/cleanTitle';
import { toast } from 'react-toastify';
import {producaov2 } from '../../../services/apis';
import NewTextEditor from '../../../components/Admin/NewTextEditor';
import replaceSpecialCaracter from '../../../utils/replaceSpecialCaracters';

function ResumosDeAulaActions({ id, onDelete, onEdit, initialDescription, nameLesson }) {
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const description = useRef("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleSave = useCallback(async () => {
    if (!description.current.trim()) {
      toast.error('O resumo não pode estar vazio');
      return;
    }
    try {
      await producaov2.put(`/ai/lesson/description/${id}`, { description: description.current });
      toast.success('Resumo atualizado com sucesso');
      onEdit();
    } catch (err) {
      toast.error('Houve um erro ao atualizar o resumo da aula');
      return err;
    } finally {
      handleClose();
    }
  }, [id, description, onEdit, handleClose]);

  const deleteResumoDeAula = useCallback(
    async () => {
      swal(
        "Exclusão de resumo",
        "Deseja realmente deletar o resumo dessa lição?",
        "error",
        {
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            cancel: {
              text: "Cancelar",
              value: false,
              visible: true,
              className: "",
              closeModal: true,
            },
            confirm: {
              text: "Confirmar",
              value: true,
              visible: true,
              className: "",
              closeModal: true,
            },
          },
        }
      ).then(async value => {
        setLoadingDelete(true);

        if (value) {
          try {
            await producaov2.delete(`/ai/lesson/description/${id}`);

            onDelete();

          } catch (err) {
            toast.error('Houve um erro ao deletar o resumo da aula')
            return err;
          }
        } else {
          return;
        }
      })
      .finally(() => {
        setLoadingDelete(false);
      });
    },
    [id]
  );

  return (
    <Box>
      <IconButton title="Editar resumo" size="small" onClick={handleClickOpen}>
        <Edit color="primary" />
      </IconButton>
      <IconButton title="Excluir aluno" size="small" onClick={deleteResumoDeAula} disabled={loadingDelete}>
        {loadingDelete ? <CircularProgress size={14} /> : <DeleteForever color="error" />}
      </IconButton>
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth={true} >
      <DialogTitle id="form-dialog-title">Edição do resumo da lição: {nameLesson}</DialogTitle>
      <DialogContent>
        <NewTextEditor
            haveFullscreen
            default={initialDescription}
            text={description}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  </Box>
  )
}


export default function ResumosDeAula() {
  const {
    data,
    totalRecords,
    isLoading,
    currentPage,
    rowsPerPage,
    currentFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleSubmitFilters,
    handleResetFilters,
    refreshData, 
  } = useResumosDeAula();

  const tableRows = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.map(item => ({
      id_curso: item.licao?.curso?.id || '-',
      nome_curso: cleanTitle(item.licao?.curso?.curso) || '-',
      nome_licao: replaceSpecialCaracter(item.licao?.titulo) || '-',
      data_atualizacao: item.updated_at ? formatDate(item.updated_at, 'dd/MM/yyyy HH:mm') : '-',
      actions: <ResumosDeAulaActions id={item.id_lesson} onDelete={refreshData} onEdit={refreshData} initialDescription={item.description} nameLesson={replaceSpecialCaracter(item.licao?.titulo)} />,
    }));
  }, [data, refreshData]);

    const columns = useMemo(() => [
    { key: 'id_curso', name: 'ID Curso', isSingleLine: true, sortable: true },
    { key: 'nome_curso', name: 'Nome Curso', isSingleLine: true, maxWidth: '300px', sortable: true },
    { key: 'nome_licao', name: 'Nome da Lição', isSingleLine: true, maxWidth: '300px', sortable: true },
    { key: 'data_atualizacao', name: 'Data Atualização', isSingleLine: true, maxWidth: '200px', sortable: true },
    { key: 'actions', name: 'Ações', isSingleLine: true },
  ], []);


  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
        <AdminMenu />
        <DataTable
          showFilters
          showPagination
          defaultOpenedFilters
          maxHeight="70vh"
          hasStickHeader
          filters={[
            {
              key: RESUMOS_FILTERS.SEARCH,
              name: 'Buscar',
              component: { type: 'text', placeholder: 'Busque pelo ID, Nome do curso ou Nome da lição' }
            },
          ]}
          columns={columns}
          rows={tableRows}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          isLoading={isLoading}
          selectedFilters={currentFilters}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          onRowsPerChange={handleRowsPerPageChange}
          onSubmitFilters={handleSubmitFilters}
          onResetFilters={handleResetFilters}
          CustomToolbarElement={
            <Typography variant="h5" component="h1">Resumos de Aula</Typography>
          }
        />
      </Box>
    </Box>
  );
}